import React, { useCallback, useEffect, useState } from 'react';
import { hr } from '../../face/hrApi';

const todayPK = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Karachi' }).format(new Date());
const VERDICT = { ok: ['Matches', 'ok'], differs: ['Times differ', 'warn'], face_missing: ['Not on kiosk', 'off'], ams_missing: ['Not in AMS', 'warn'] };

export default function FaceCompareTab({ live }) {
  const [date, setDate] = useState(todayPK());
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const load = useCallback(async () => {
    try { setData(await hr(`/shadow-compare?date=${date}`)); setErr(''); } catch (e) { setErr(e.message); }
  }, [date]);
  useEffect(() => { load(); }, [load]);

  const s = data?.summary;
  return (
    <div className="fc-card">
      <div className="fc-toolbar">
        <h3>Kiosk vs. attendance records</h3>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        <button className="fc-btn fc-btn-ghost fc-btn-sm" onClick={load}>Refresh</button>
      </div>
      <p className="fc-muted">{live ? 'The kiosk is live, so both columns come from the same punches. Differences show people who used the phone instead.' : 'Test mode: the kiosk times below are what the face punch would have recorded. Compare them with what staff actually clocked from the app. Use a week of this before going live.'}</p>
      {err && <div className="fc-callout fc-bad">{err}</div>}
      {s && (
        <div className="fc-stats fc-stats-row">
          <span><b>{s.both}</b> on both</span><span><b>{s.face_only}</b> kiosk only</span><span><b>{s.ams_only}</b> app only</span><span><b>{s.differs}</b> times differ by over 15 min</span>
        </div>
      )}
      {!data ? <div className="fc-muted">Loading…</div> : data.rows.length === 0 ? <div className="fc-muted">No kiosk or attendance activity on this date.</div> : (
        <div className="fc-table-wrap">
          <table className="fc-table">
            <thead><tr><th>Employee</th><th>Kiosk in</th><th>App/AMS in</th><th>Diff</th><th>Kiosk out</th><th>App/AMS out</th><th>Late (kiosk / AMS)</th><th>Result</th></tr></thead>
            <tbody>
              {data.rows.map((r) => {
                const v = VERDICT[r.verdict] || [r.verdict, 'off'];
                return (
                  <tr key={r.id}>
                    <td><b>{r.name}</b> <span className="fc-muted fc-small">{r.code}</span></td>
                    <td>{r.face_in || '—'}</td><td>{r.ams_in || '—'}</td>
                    <td>{r.in_diff_min == null ? '—' : `${r.in_diff_min > 0 ? '+' : ''}${r.in_diff_min} min`}</td>
                    <td>{r.face_out || '—'}</td><td>{r.ams_out || '—'}</td>
                    <td>{r.face_late ?? '—'} / {r.ams_late ?? '—'}{r.late_match === false ? <span className="fc-late"> ≠</span> : null}</td>
                    <td><span className={`fc-pill fc-pill-${v[1]}`}>{v[0]}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
